import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// Ed 8/7: the rates-checked stamp moved OUT of Hope's opening bubble (it was eating vertical
// real estate) to a small centered line above the * Advertising Disclosure link. The step that
// paints the reviewed rate publishes the display text; the rates-form shell renders it.
@Injectable({ providedIn: 'root' })
export class RateFreshnessService {
  private readonly displaySubject = new BehaviorSubject<string>('');
  readonly display$ = this.displaySubject.asObservable();

  get value(): string { return this.displaySubject.value; }

  set(text: string): void {
    try { this.displaySubject.next((text || '').trim()); } catch (e) { /* non-fatal */ }
  }

  clear(): void { this.set(''); }
}
